<script>


export default {
    emits: {
        'onStepCompleted'(resultObj) {
            return resultObj;
        }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },

        stepInfo: {
            type: Object,
            required: true
        },
        stepId : {
            type: String,
            required: true
        }
    },

    mounted() {
    },

    data() {
        return {

        }
    },

    methods: {
        onValueChanged(e) {
            console.log(e);
            if( typeof e === 'undefined') {
                return;
            }

            this.$emit("onStepCompleted", {source: this.stepId, value: e.target.value});
        }
    }
}
</script>
    
<template>

    <div class="row mt-4 mb-4 ">
        <div class="col">
            <h4>{{ title }}</h4>
            <p v-if="description">{{ description }}</p>

            <input @keyup="onValueChanged($event)" class="form-control" />

        </div>

    </div>

</template>